import { MessagePreviewOrderProps } from "../types"
import React from "react"
import { useTheme } from "~/ui/styled"
import PreviewWrap from "./preview-wrap"
import PreviewText from "./preview-text"
// import { formatPrice } from "~utils"
// import { useStores } from "~models"
import { Text } from "~components/El"

const MessagePreviewRed: React.FC<MessagePreviewOrderProps> = ({
  senderName,
  forwardPrependMsg,
  message,
}) => {
  const theme= useTheme()
  // const { userStore } = useStores()
  // const isReceiver = (message.receiver as any)?.id === userStore.currentUser?.id
  const contentOverride = message?.attach?.redpacket_info?.blessing_words || "恭喜发财, 大吉大利"
  return (
    <PreviewWrap>
      <PreviewText numberOfLines={1}>
        {senderName}
        {forwardPrependMsg}
        <Text color={theme.colors.error}> {'[红包]'} </Text>
        {contentOverride}
      </PreviewText>
    </PreviewWrap>
  )
}
export default MessagePreviewRed
